module.exports = __webpack_public_path__ + "media/images/athletes/1615-9cd07235906af3d1ce50d8e960250aaf.png";